import React, { useEffect, useState } from "react";
import styles from "./Hero.module.css";

const slides = [
  "https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1509316785289-025f5b846b35?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=1600&q=80",
];

const SLIDE_DURATION_MS = 5500;

function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, SLIDE_DURATION_MS);
    return () => clearInterval(timer);
  }, []);

  const handleBookTripClick = (e) => {
    e.preventDefault();
    const target = document.getElementById("packages");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className={styles.hero}>
      <div className={styles.slideStack}>
        {slides.map((src, idx) => (
          <div
            key={src}
            className={`${styles.slide} ${
              idx === activeIndex ? styles.slideActive : ""
            }`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
        <div className={styles.overlay} />
      </div>

      <div className={styles.content}>
        <p className={styles.eyebrow}>
          Tripontourism &middot; Dubai's #1 Rated Desert Experience
        </p>
        <h1 className={styles.heading}>
          Unforgettable Desert Safari
          <br />
          Dubai Adventures!
        </h1>
        <p className={styles.subheading}>
          Dune bashing, camel rides, BBQ dinners &amp; unforgettable sunsets —
          all in one trip.
        </p>
        <button
          type="button"
          className={styles.ctaBtn}
          onClick={handleBookTripClick}
        >
          Book Your Trip Now
        </button>

        <div className={styles.dots}>
          {slides.map((_, idx) => (
            <button
              key={idx}
              type="button"
              className={`${styles.dot} ${
                idx === activeIndex ? styles.dotActive : ""
              }`}
              aria-label={`Show slide ${idx + 1}`}
              onClick={() => setActiveIndex(idx)}
            />
          ))}
        </div>

        <div className={styles.scrollHint} aria-hidden="true">
          <span className={styles.scrollArrow}>⌄</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;
